import { Component, OnInit } from '@angular/core';
import '@pru/ret-indv-income-calculator-ui/lib/components/ric-promo-banner/ric-promo-banner';
import { AggregationService } from 'src/app/services/aggregation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ric-wc',
  templateUrl: './ric-wc.component.html',
  styleUrls: ['./ric-wc.component.scss']
})
export class RicWcComponent implements OnInit {
  planningURL: string;
  private subscription: Subscription;
  loadRic: boolean;
  constructor(
    private _aggregationService: AggregationService,
  ) { }
  ngOnInit() {
    this.subscription = this._aggregationService.aggregationDone.subscribe((res: any) => {
      if (res && res === 'aggregationDone') {
        this.subscription.unsubscribe();
        this.loadRic = true;
      }
    }
    );
  }
}